<template>
  <div class="content" @keydown.shift="handleShiftKeyDown" @keyup="handleShiftKeyUp">
    <div class="alert-content">
      <el-alert title="注意事项" description="ICCID列表和ICCID范围任选一项填写，不能都为空" type="info" show-icon :closable="false"></el-alert>
    </div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm">
      <el-form-item label="代理商：" prop="userId" label-width="151px">
        <el-select v-model="ruleForm.userId" filterable placeholder="代理商" @change="changeUser" style="width: 330px">
          <el-option v-for="item in agentList" :key="item.userId" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流量池：" prop="poolId" label-width="151px">
        <el-select v-model="ruleForm.poolId" filterable placeholder="流量池"  clearable style="width: 330px">
          <el-option v-for="item in poolList" :key="item.id" :label="item.poolName" :value="item.id"></el-option>
        </el-select>
        <el-button type="primary" size="medium" plain @click="queryCard" style="margin-left: 20px">查卡</el-button>
      </el-form-item>
      <el-form-item label="ICCID列表：" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          :placeholder="'以回车键分割ICCID\n最多200条数据'"
          rows="6"
          clearable
          style="width:420px;font-size:14px"
          @input="handleCardSum"
        ></el-input>
        <div style="color:#606266;padding-left: 340px;">条数：{{iccidCount}}条</div>
      </el-form-item>
      <el-form-item label="ICCID范围：" prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 198px;margin-right: 10px;"
          placeholder="包含开始值"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 198px;margin-left: 10px;"
          placeholder="包含终止值"
        ></el-input>
      </el-form-item>
      <el-form-item label="过期时间：" prop="dateType" label-width="151px">
        <el-radio-group v-model="ruleForm.dateType">
          <el-radio label="1">按（月）</el-radio>
          <el-radio label="2">自定义时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="cycleTime" v-if="ruleForm.dateType=='1'" label-width="151px">
        <el-input-number v-model="ruleForm.cycleTime" :min="1"></el-input-number>
        <p class="alert-tip">按卡的过期时间自动延长多少个月，卡过期时间非最后一天，此月作为周期开始月，否则此月的下一个月作为开始月，按自然月计算</p>
      </el-form-item>
      <el-form-item prop="cardRenewalTime" v-if="ruleForm.dateType=='2'" label-width="151px">
        <el-date-picker v-model="ruleForm.cardRenewalTime" value-format="yyyy-MM-dd" type="date" placeholder="卡的过期时间"></el-date-picker>
        <p class="alert-tip">自定义卡的过期时间</p>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')" style="margin: 20px 50px">提交</el-button>
        <el-button type="primary" size="medium" plain @click="reset('ruleForm')" style="margin: 20px">重置</el-button>
      </el-form-item>
    </el-form>

    <!--卡列表弹窗-->
    <el-dialog title="池卡列表" width="1200px" :visible.sync="cardListDialogVisible" @close="cardListDialogClose" v-dialogDrag :modal-append-to-body="false" :close-on-click-modal="false">
      <el-form :model="queryParams" :inline="true">
        <el-form-item prop="iccid">
          <el-input v-model="queryParams.iccid" placeholder="ICCID/ICCIDS/MSISDN/MSISDNS"  clearable ></el-input>
        </el-form-item>
      
        <el-form-item  prop="startIccid">
          <el-input v-model="queryParams.startIccid" placeholder="开始ICCID/MSISDN范围"  clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="endIccid">
          <el-input v-model="queryParams.endIccid" placeholder="结束ICCID/MSISDN范围"  clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="dateRange">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            @change="selectPoolCards"
            type="daterange"
            range-separator="-"
            start-placeholder="过期开始日期"
            end-placeholder="过期结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="selectPoolCards">搜索</el-button>
          <el-button  icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="padding:10px 0;">选中条数：{{selectedCardList.length}}条</div>
      <el-table :data="cardList" border :height="600" :header-cell-style ="{background: '#EEF1F6',color: '#606266'}"
                @select="handleSelection" @select-all="handleSelectionAll" @sort-change="tableSortChange" ref="multipleTable">
        <el-table-column type="selection" align="center" ></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="useFlow" label="当月流量" align="center"></el-table-column>
        <el-table-column prop="activeTime" label="激活时间" align="center"></el-table-column>
        <el-table-column prop="cardExpireTime" label="过期时间" align="center" sortable="custom"></el-table-column>
      </el-table>
      <el-button type="primary" size="medium" @click="confirmCardList" style="margin: 20px 200px">确定</el-button>
      <el-button type="primary" size="medium" @click="downCardList" v-hasPermi="['pondManage:pondDetails:down']">下载</el-button>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPoolCardList,
  poolGetFlowPoolCardListExport,
  poolGetFlowPoolList,
  agentDataList,
  poolRenewal
} from "@/api/api.js"; //卡分配的提交
export default {
  name:"pondRenewal",
  data() {
    return {
      agentList:[],
      poolList:[],
      cardList:[],
      ruleForm: {
        userId:undefined,
        poolId:undefined,
        cardRenewalTime:undefined,
        iccids: undefined,
        dateType:"2",
        cycleTime:12
      },
      shiftKey:"up",
      submitLoading:false,
      rules: {
        userId: [
          { required: true, message: "代理商不能为空", trigger: "blur" },
        ],
        cycleTime: [
          { required: true, message: "周期不能为空", trigger: "blur" },
        ],
        dateType:[
          { required: true, message: "请选择过期类型", trigger: "blur" },
        ],
        cardRenewalTime:[
          { required: true, message: "过期时间不能为空", trigger: "blur" },
        ]
      },
      cardListDialogVisible:false,
      selectedCardList:[],
      iccidCount:0,
      dateRange:[],
      queryParams:{
        iccid:undefined,
        startIccid:undefined,
        endIccid:undefined,
      },
      sortOrder:'',
      sortName:'',
    };
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'pondRenewal'){
          this.initParams();
          if(to.params.poolId){
              this.handleIccids()
          }
          if(!!to.params.type){
              this.ruleForm = {}
          }
        }
      },
      deep: true
    },
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
    cardIccids(){
      return this.$store.state.card.poolCardIccids;
    },
  },
  methods: {
    handleIccids(){
      if(this.cardIccids){
        let arrIccids = this.cardIccids.split(",");
        this.ruleForm.iccids = arrIccids.join("\n");
        this.iccidCount = arrIccids.length;
      }else{
        this.ruleForm.iccids ='';
        this.iccidCount =0;
      }
    },
    // 获取流量池用户
    selectPoolAgent(){
      agentDataList({commissionModel:'2'}).then(res => {
        this.agentList = res.data.data
      })
    },
    // 切换用户
    changeUser(userId){
      this.ruleForm.poolId = undefined;
      let status = "1";
      poolGetFlowPoolList({userId,status}).then(res=>{
        this.poolList = res.data.data;
      })
    },
    // 获取用户流量池
    getFlowPool(){
      poolGetFlowPoolList({userId:this.ruleForm.userId,status:"1"}).then(res=>{
        this.poolList = res.data.data;
      })
    },
    // 查看卡
    queryCard(){
      if(!this.ruleForm.poolId){
        this.$message.error("请先选择一个流量池");
        return;
      }
      this.cardListDialogVisible = true
      this.selectPoolCards()
    },
    handleCardSum(){
      let iccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n"):[];
      this.iccidCount = iccids.filter(item=>!!item).length
    },
    selectPoolCards(){
      let model={
        order: this.sortOrder,
        sort: this.sortName,
        poolId:this.ruleForm.poolId,
        ... this.addDateRange(this.queryParams, this.dateRange),
      }
      getPoolCardList(model).then(res=>{
          this.cardList = res.data.data;
      })
    },
    cardListDialogClose(){
      this.cardListDialogVisible = false
    },
    handleSelectionAll(selection){
      this.selectedCardList = selection;
    },
    handleSelection(selection, row) {
      if(this.shiftKey === "down" && selection.length > 1){
        const sortArr = this.selectedCardList.map(obj => obj.sort);
        const minValue = Math.min(...sortArr);
        if(minValue === row.sort){
          this.selectedCardList = [this.cardList[row.sort]];
        } else if(minValue > row.sort){
          this.selectedCardList = this.cardList.slice(row.sort,minValue+1);
        } else if(minValue < row.sort) {
          this.selectedCardList = this.cardList.slice(minValue,row.sort+1);
        }
        const selectedCardListSortArr = this.selectedCardList.map(obj => obj.sort);
        this.cardList.forEach((item, i) => {
          if(selectedCardListSortArr.includes(item.sort)){
            this.$refs.multipleTable.toggleRowSelection(item, true);
          } else {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }
        });
      } else {
        this.selectedCardList = selection;
      }
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      this.sortName = val.prop == "cardExpireTime" ? "expireTime" : "iccid";
      this.selectPoolCards();
    },
    confirmCardList(){
      if(this.selectedCardList.length > 0){
        let arrList = [];
        this.selectedCardList.map(item=>{
          arrList.push(item.iccid);
        });
        this.iccidCount = arrList.length
        this.ruleForm.iccids = arrList.toString().replaceAll(",","\n")
      }
      this.cardListDialogVisible = false;
      this.sortOrder = "";
      this.sortName = "";
    },
    downCardList(){
      let params = {
        poolId:this.ruleForm.poolId,
      }
      poolGetFlowPoolCardListExport(params).then(res=>{
        this.$notify({
          title: "成功",
          message: "成员列表导出成功，请在任务中心查看",
          type: "success",
          offset:30
        });
        this.cardListDialogVisible = false;
        this.sortOrder = "";
        this.sortName = "";
      })
    },
    handleShiftKeyDown(event){
      if (event.key === 'Shift') {
        this.shiftKey = "down";
      }
    },
    handleShiftKeyUp(event){
      if (event.key === 'Shift') {
        this.shiftKey = "up";
      }
    },
    reset(){
      this.ruleForm = {
        userId:undefined,
        poolId:undefined,
        cardRenewalTime:undefined,
        iccid:undefined
      }
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let { iccids } = this.ruleForm;
          let params = {
            ...this.ruleForm,
            iccids:iccids ? iccids.split("\n") : []
          };
          poolRenewal(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "已提交卡续约，请在任务中心查看进度",
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.ruleForm ={};
              this.$router.push({ path: `/taskCenter/missionList`});
            },1000)
          })
        }
      });
    },
    initParams(){
      let userId = this.$route.params && this.$route.params.userId;
      let poolId = this.$route.params && this.$route.params.poolId;
      if(!!poolId){
        this.ruleForm.userId = userId
        let status = "1";
        poolGetFlowPoolList({userId,status}).then(res=>{
          this.poolList = res.data.data;
          this.ruleForm.poolId = poolId+""
        })
      }
    },
    // 重置
    resetQuery(){
      this.queryParams = {};
      this.dateRange = []
      this.selectPoolCards();
    },
  },
  created() {
    this.selectPoolAgent();
    this.handleIccids()
    this.initParams()
  },
};
</script>
<style  scoped lang="less">
.alert-content{
  width: 420px;
  margin-left:60px ;
  margin-bottom: 30px;
}
</style>
